import { render, staticRenderFns } from "./ChartBarTotal.vue?vue&type=template&id=3317a872"
import script from "./ChartBarTotal.vue?vue&type=script&lang=js"
export * from "./ChartBarTotal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports